module.exports = __webpack_public_path__ + "assets/images/logo-intro_108baadf5ff3ee1e2a16cd83560f3975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-intro.png
// module id = 188
// module chunks = 0